const featureFlags = {};

export type FeatureFlag = keyof typeof featureFlags;

export default featureFlags;
